class Popup {
    popupWrapper;
    buttons;
    popupID;
    closeBtn;

    constructor(popupWrapper) {
        this.popupWrapper = popupWrapper;
        this.init();
    }

    init = () => {
        this.popupID = this.popupWrapper.dataset['popupId'];
        this.buttons = document.querySelectorAll(`[data-popup="${this.popupID}"]`);
        this.layout = this.popupWrapper.querySelector('.popup-layout');
        this.closeBtn = this.popupWrapper.querySelector('.popup__close-btn');
        this.closeSecond = this.popupWrapper.querySelectorAll('.btn-close');
        this.buttons.forEach((button) => {
            button.addEventListener('click', this.onButtonClick);
        });
        this.layout.addEventListener('click', this.onCloseButtonClick);

        this.closeBtn.addEventListener('click', this.onCloseButtonClick);
        this.closeSecond.forEach(item => {
            item.addEventListener('click', this.onCloseButtonClick)
        })
    }

    onButtonClick = (evt) => {
        evt.preventDefault();
        this.popupWrapper.classList.add('active');
        setTimeout(() => {
            this.popupWrapper.classList.add('active-anim');
        })
        document.body.classList.add('disable-scroll');
        document.documentElement.classList.add('disable-scroll');
    }

    onCloseButtonClick = (evt) => {
        evt.preventDefault();
        this.popupWrapper.classList.remove('active-anim');
        this.popupWrapper.classList.remove('active');
        document.body.classList.remove('disable-scroll');
        document.documentElement.classList.remove('disable-scroll');
    }


}

export {Popup};
